import React, { useState, useEffect } from 'react';
import './Header.css';
import config from '../../config/config';
import { fetchData } from '../../config/dataService';

const NAV_ITEMS = [
  { id: 'home',     label: 'Home'     },
  { id: 'reviews',  label: 'Reviews'  },
  { id: 'howto',    label: 'How To'   },
  { id: 'faq',      label: 'FAQ'      },
  { id: 'contacts', label: 'Contacts' },
];

export default function Header({ activePage, onNavigate }) {
  const [menuOpen,  setMenuOpen]  = useState(false);
  const [heroData,  setHeroData]  = useState(null);

  // Load hero data from S3 once on mount
  useEffect(() => {
    fetchData('home')
      .then(data => setHeroData(data?.hero || {}))
      .catch(() => setHeroData({}));
  }, []);

  const handleNav = (id) => {
    onNavigate(id);
    setMenuOpen(false);
  };

  return (
    <header className="header">

      {/* ── Banner image — always shown on every page ── */}
      <div className="header__hero">
        <img
          className="header__hero-image"
          src={heroData?.bannerImage || '/assets/banner.png'}
          alt={heroData?.bannerAlt   || config.SITE_TITLE}
        />
        <div className="header__hero-overlay" />

        {/* Site title / tagline centred over banner */}
        <div className="header__hero-content">
          <p className="header__hero-eyebrow">
            {heroData?.eyebrow || 'Welcome to'}
          </p>
          <h1 className="header__hero-title">
            {heroData?.titleLine1 || 'Serenity'}{' '}
            <em>{heroData?.titleLine2 || 'In Strand'}</em>
          </h1>
          <p className="header__hero-tagline">
            {heroData?.tagline || config.SITE_TAGLINE}
          </p>
        </div>
      </div>

      {/* ── Nav bar — sits at the bottom edge of the banner ── */}
      <div className="header__bar">
        <div className="header__inner">

          {/* Brand */}
          <div
            className="header__brand"
            onClick={() => handleNav('home')}
            style={{ cursor: 'pointer' }}
          >
            <span className="header__brand-title">{config.SITE_TITLE}</span>
            <span className="header__brand-subtitle">{config.SITE_TAGLINE}</span>
          </div>

          {/* Desktop nav */}
          <nav className="header__nav" aria-label="Main navigation">
            {NAV_ITEMS.map(({ id, label }) => (
              <button
                key={id}
                className={`nav__link${activePage === id ? ' active' : ''}`}
                onClick={() => handleNav(id)}
                aria-current={activePage === id ? 'page' : undefined}
              >
                {label}
              </button>
            ))}
          </nav>

          {/* Hamburger */}
          <button
            className={`header__hamburger${menuOpen ? ' open' : ''}`}
            onClick={() => setMenuOpen(v => !v)}
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
          >
            <span /><span /><span />
          </button>
        </div>

        {/* Mobile menu */}
        <nav
          className={`header__mobile-menu${menuOpen ? ' open' : ''}`}
          aria-label="Mobile navigation"
        >
          {NAV_ITEMS.map(({ id, label }) => (
            <button
              key={id}
              className={`nav__link${activePage === id ? ' active' : ''}`}
              onClick={() => handleNav(id)}
            >
              {label}
            </button>
          ))}
        </nav>
      </div>

    </header>
  );
}
